import { render, staticRenderFns } from "./suggestionInfo.vue?vue&type=template&id=e7b587d8"
import script from "./suggestionInfo.vue?vue&type=script&lang=js"
export * from "./suggestionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7b587d8')) {
      api.createRecord('e7b587d8', component.options)
    } else {
      api.reload('e7b587d8', component.options)
    }
    module.hot.accept("./suggestionInfo.vue?vue&type=template&id=e7b587d8", function () {
      api.rerender('e7b587d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestionInfo.vue"
export default component.exports